import {
  PostAddOutlined,
  GroupsOutlined,
  CalendarTodayOutlined,
  LocationOnOutlined,
  FormatAlignJustifyOutlined,
  SettingsOutlined,
  Mode,
  AddCircleOutlineOutlined
} from '@mui/icons-material';
import { UserTypes } from '../enums';
import { ItemSidebar } from '../interfaces';

const items: ItemSidebar[] = [
  {
    href: 'projectDetails',
    icon: (active: boolean) => (<SettingsOutlined fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
    title: 'Project Details',
  },
  {
    href: 'creative-docs',
    icon: (active: boolean) => (<PostAddOutlined fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
    title: 'Creative Docs',
  },
  {
    href: 'contacts',
    icon: (active: boolean) => (<GroupsOutlined fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
    title: 'Project Contacts',
    // child: [
    //   {
    //     href: 'contacts',
    //     title: 'All Contacts',
    //   },
    // ],
  },
  // {
  //   href: 'workflow',
  //   icon: (active: boolean) => (<ShareOutlined fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
  //   title: 'Workflow',
  // },
  {
    href: 'calendar',
    icon: (active: boolean) => (<CalendarTodayOutlined fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
    title: 'Project Calendar',
  },
  // {
  //   href: 'onboarding-docs',
  //   icon: (active: boolean) => (<CheckBoxOutlined fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
  //   title: 'Onboarding Docs',
  // },
  {
    href: 'locations',
    icon: (active: boolean) => (<LocationOnOutlined fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
    title: 'Locations',
  },
  {
    href: 'call-sheet',
    icon: (active: boolean) => (<FormatAlignJustifyOutlined fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
    title: 'Call Sheet',
    // child: [
    //   {
    //     href: 'call-sheet',
    //     title: 'All Call Sheet',
    //   },
    // {
    //   href: '#',
    //   title: 'Crew',
    // },
    // {
    //   href: '#',
    //   title: 'Talent',
    // },
    // {
    //   href: '#',
    //   title: 'Extras',
    // },
    // {
    //   href: '#',
    //   title: 'Clients',
    // },
    // ],
  },
  // {
  //   href: 'budget',
  //   icon: (active: boolean) => (<StackedBarChartOutlined fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
  //   title: 'Budget',
  // },
  // {
  //   href: '',
  //   icon: (active: boolean) => (<PointOfSaleOutlined fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
  //   title: 'Payroll',
  //   child: [
  //     {
  //       href: '#',
  //       title: 'Test',
  //     },
  //   ],
  // },
  // {
  //   href: '/privacy-policy',
  //   icon: (active: boolean) => (<SettingsOutlined fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
  //   title: 'Settings',
  // },
  {
    href: 'notes',
    icon: (active: boolean) => (<Mode fontSize="small" sx={{ color: active ? '#FEB100' : '#fff' }} />),
    title: 'Notes',
  },

];

const itemsAdmin = (userType: string) => {
  if (userType === UserTypes.CREW_MEMBER) {
    return items.filter((item) => !excludeCrew.includes(item.href));
  }
  return items;
}

const excludeCrew = ['locations'];

const routes = {
  itemsAdmin,
}

export default routes;
